const COLS = [
  {
    t: "栏目导览",
    links: [
      { l: "实时热瓜榜", h: "#hot" },
      { l: "反转追踪", h: "#reversal" },
      { l: "编辑精选", h: "#editor" },
      { l: "分类瓜田", h: "#category" },
    ],
  },
  {
    t: "追更说明",
    links: [
      { l: "热瓜问答", h: "#faq" },
      { l: "关于我们", h: "#about" },
      { l: "编辑部手记", h: "#editor" },
      { l: "回到顶部", h: "#top" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-paper-100 border-t border-ink-200/60 text-ink-800">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-brand-500 flex items-center justify-center text-paper-50">
                <i className="ri-fire-fill text-xl" />
              </span>
              <span className="font-heading font-black text-xl text-ink-900">今日热瓜</span>
            </div>
            <p className="mt-4 max-w-sm text-sm text-ink-600 leading-relaxed">
              事件发酵、二次爆料与反转剧情持续更新到最新。想看哪个瓜走到哪一步，顺着持续更新就能读。
            </p>
            <a
              href="mailto:contact@jinriregua.top"
              className="mt-4 inline-flex items-center gap-2 text-sm text-ink-700 hover:text-brand-600"
            >
              <i className="ri-mail-line" />
              contact@jinriregua.top
            </a>
          </div>

          {COLS.map((c) => (
            <nav key={c.t} className="md:col-span-2" aria-label={c.t}>
              <h4 className="font-bold text-ink-900 mb-4">{c.t}</h4>
              <ul className="space-y-2.5">
                {c.links.map((l) => (
                  <li key={l.l}>
                    <a href={l.h} className="text-sm text-ink-600 hover:text-brand-600 transition-colors">
                      {l.l}
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}

          <div className="md:col-span-3">
            <h4 className="font-bold text-ink-900 mb-4">订阅最新进展</h4>
            <p className="text-sm text-ink-600 mb-3">把今日热瓜榜单发到你邮箱，每天一次，不刷屏。</p>
            <a
              href="mailto:contact@jinriregua.top"
              className="inline-flex items-center gap-1.5 px-4 h-10 rounded-full bg-ink-900 text-paper-50 text-sm font-semibold hover:bg-ink-700 whitespace-nowrap"
            >
              邮件联系编辑部
              <i className="ri-arrow-right-line" />
            </a>
            <p className="text-xs text-ink-400 mt-3">订阅与投稿请通过邮箱沟通，我们会在一个工作日内回复。</p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-ink-200/70 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-ink-500">
          <p>本站内容基于公开渠道整理呈现，人物与节目设定仅作栏目展示，不构成对任何当事人的事实认定；是非曲直请以官方与本人公开回应为准。</p>
          <p className="whitespace-nowrap">© {new Date().getFullYear()} 今日热瓜 · 追瓜到最新</p>
        </div>
      </div>
    </footer>
  );
}